import { ValidationRuleSchema } from 'vee-validate/dist/types/types'

const TelNumber: ValidationRuleSchema = {
  validate(value: string) {
    return /^([0-9]{10,11}|[0-9]{2,4}-[0-9]{2,4}-[0-9]{3,4})$/.test(value)
  },
}

export default TelNumber
